var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { GltfProduct } from "../gltfModel";
import { ColladaProduct } from "../colladaModel";
import { ModelType } from "./config";
// Load a vortex product if model can be loaded from given configuration
export function loadModelFromConfig(modelConfig) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    // Try to determine the model format by its type
    // Model config tool should always provide this
    if (modelConfig.type) {
      if (modelConfig.type === ModelType.dae) {
        return new ColladaProduct(modelConfig);
      }
      if (modelConfig.type === ModelType.glb) {
        return new GltfProduct(modelConfig);
      }
      throw new Error("The model type: ".concat(modelConfig.type, " is not supported!"));
    }
    // Otherwise get from file format
    const modelResponse = yield fetch(modelConfig.modelUri, {
      method: "HEAD"
    });
    if (modelResponse.status >= 400) {
      throw new Error("Failed to fetch the model asset at '".concat(modelConfig.modelUri, "'"));
    }
    // Otherwise look at the headers to determine glb vs dae
    const isGlt = (_a = modelResponse.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("binary");
    return isGlt ? new GltfProduct(modelConfig) : new ColladaProduct(modelConfig);
  });
}